import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_KEY || "my_super_secret_key_123";

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
};

export const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (err) {
    return null;
  }
};

/**
 * Encrypts a string value for URL usage.
 */
export const encrypt = (text) => {
  if (!text) return '';
  try {
    const ciphertext = CryptoJS.AES.encrypt(text.toString(), SECRET_KEY).toString();
    return ciphertext.replace(/\//g, '_').replace(/\+/g, '-');
  } catch (err) {
    console.error("Encryption error:", err);
    return '';
  }
};

/**
 * Decrypts an encrypted string value.
 */
export const decrypt = (encryptedText) => {
  if (!encryptedText) return '';
  try {
    const safeCiphertext = encryptedText.replace(/_/g, '/').replace(/-/g, '+');
    const bytes = CryptoJS.AES.decrypt(safeCiphertext, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("Decryption error:", err);
    return '';
  }
};